module.exports = __webpack_public_path__ + "img/color4.9c53278c.png";